module.exports = __webpack_public_path__ + "c5f47050c8a999e1e428a7c79f47f0e4.jpg";